import { DRIVER_ROUTES } from './routes-typed'

export type RouteMode = 'group' | 'single'

export type DriverRouteConfigItem = {
  /** Shared identifier across group/single variants */
  id: string
  mode: RouteMode
  /** Original key from your legacy map */
  key: string
  /** React Router path template */
  path: string
}

export const driverRoutesConfig: DriverRouteConfigItem[] = [
  { id: 'contracts', mode: 'single', key: 'driverContracts', path: DRIVER_ROUTES.contracts.path },
  { id: 'activities', mode: 'single', key: 'driverActivities', path: DRIVER_ROUTES.activities.path },
  { id: 'chartDetails', mode: 'single', key: 'driverChartDetails', path: DRIVER_ROUTES.chartDetails.path },
  { id: 'chartDetails', mode: 'group', key: 'driverGroupChartDetails', path: DRIVER_ROUTES.groupChartDetails.path },
  { id: 'violations', mode: 'single', key: 'driverViolations', path: DRIVER_ROUTES.violations.path },
  { id: 'violationsNew', mode: 'single', key: 'driverViolationsNew', path: DRIVER_ROUTES.violationsNew.path },
  { id: 'businessTrips', mode: 'single', key: 'driverBusinessTrips', path: DRIVER_ROUTES.businessTrips.path },
  { id: 'businessTripNewGrouped', mode: 'single', key: 'driverBusinessTripNew', path: DRIVER_ROUTES.businessTripNew.path },
  { id: 'businessTripEdit', mode: 'single', key: 'driverBusinessTripEdit', path: DRIVER_ROUTES.businessTripEdit.path },
  { id: 'timesheet', mode: 'single', key: 'driverTimesheet', path: DRIVER_ROUTES.timesheet.path },
  { id: 'schedule', mode: 'single', key: 'driverSchedule', path: DRIVER_ROUTES.schedule.path },
  { id: 'contracts', mode: 'group', key: 'driverGroupContracts', path: DRIVER_ROUTES.groupContracts.path },
  { id: 'violations', mode: 'group', key: 'driverGroupViolations', path: DRIVER_ROUTES.groupViolations.path },
  { id: 'violationsNew', mode: 'group', key: 'driverGroupViolationsNew', path: DRIVER_ROUTES.groupViolationsNew.path },
  { id: 'businessTrips', mode: 'group', key: 'driverGroupBusinessTrips', path: DRIVER_ROUTES.groupBusinessTrips.path },
  { id: 'businessTripNewGrouped', mode: 'single', key: 'driverGroupBusinessTripNew', path: DRIVER_ROUTES.businessTripNew.path },
  { id: 'timesheet', mode: 'group', key: 'driverGroupTimesheet', path: DRIVER_ROUTES.groupTimesheet.path },
  { id: 'timesheetBonusAndRewards', mode: 'group', key: 'driverGroupTimesheetBonusAndRewards', path: DRIVER_ROUTES.groupTimesheetBonusAndRewards.path },
  // Single counterpart of the group bonus & rewards view: per-driver timesheet,
  // where bonuses/rewards are edited in a modal. Must stay after the `timesheet`
  // single entry above so that page keeps resolving to its own group route.
  { id: 'timesheetBonusAndRewards', mode: 'single', key: 'driverTimesheet', path: DRIVER_ROUTES.timesheet.path },
  { id: 'foreignAmountsPreview', mode: 'single', key: 'driverForeignAmountsPreview', path: DRIVER_ROUTES.foreignAmountsPreview.path },
]

// Legacy path map. Source-of-truth is `DRIVER_ROUTES` in `routes-typed.ts`;
// every entry here just reads `.path` so the two stay in sync.
export const driversRoutesMap: Record<string, any> = {
  driverViolationsNew: DRIVER_ROUTES.violationsNew.path,
  driverContracts: DRIVER_ROUTES.contracts.path,
  driverActivities: DRIVER_ROUTES.activities.path,
  driverChartDetails: DRIVER_ROUTES.chartDetails.path,
  driverGroupChartDetails: DRIVER_ROUTES.groupChartDetails.path,
  driverViolations: DRIVER_ROUTES.violations.path,
  driverBusinessTrips: DRIVER_ROUTES.businessTrips.path,
  driverBusinessTripNew: DRIVER_ROUTES.businessTripNew.path,
  driverBusinessTripEdit: DRIVER_ROUTES.businessTripEdit.path,
  driverTimesheet: DRIVER_ROUTES.timesheet.path,
  driverSchedule: DRIVER_ROUTES.schedule.path,
  driverGroupViolationsNew: DRIVER_ROUTES.groupViolationsNew.path,
  driverGroupContracts: DRIVER_ROUTES.groupContracts.path,
  driverGroupViolations: DRIVER_ROUTES.groupViolations.path,
  driverGroupBusinessTrips: DRIVER_ROUTES.groupBusinessTrips.path,
  driverGroupBusinessTripNew: DRIVER_ROUTES.businessTripNew.path,
  driverGroupTimesheet: DRIVER_ROUTES.groupTimesheet.path,
  driverGroupTimesheetBonusAndRewards:
    DRIVER_ROUTES.groupTimesheetBonusAndRewards.path,
  driverForeignAmountsPreview: DRIVER_ROUTES.foreignAmountsPreview.path,
}
